import type { TimeSlotGridProps } from "@/components/shared/time-slot-with-search/time-slot-grid";
import { TimeSlotGrid } from "@/components/shared/time-slot-with-search/time-slot-grid";
import { useEffect, useRef } from "react";

const CARD_WIDTH = 150;
const GAP = 16; // gap-4

export const TimeSlotGridContainer = (props: TimeSlotGridProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollRef.current?.scrollTo({
      left:
        props.firstNoEmptyIndex > 0
          ? (CARD_WIDTH + GAP) * props.firstNoEmptyIndex
          : 0,
      behavior: "smooth",
    });
  }, [props.firstNoEmptyIndex]);

  return (
    <div
      className="relative min-h-80 overflow-x-scroll rounded-lg border border-secondary-border bg-background-intermediate"
      ref={scrollRef}
    >
      <TimeSlotGrid {...props} />
    </div>
  );
};
